const INITIAL_FEN = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

function tag(value: string): string {
  return value
    .replace(/[\r\n]+/g, ' ')
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"');
}

/** Format server-supplied SAN; no move legality or position identity is computed. */
export function studyPgn(fen: string, name: string, movesSan: string[] = []): string {
  const headers = [
    `[Event "${tag(name)}"]`,
    '[Site "ItsAllPrep"]',
    '[Date "????.??.??"]',
    '[Round "-"]',
    '[White "?"]',
    '[Black "?"]',
    '[Result "*"]',
  ];
  if (fen !== INITIAL_FEN) headers.push('[SetUp "1"]', `[FEN "${tag(fen)}"]`);
  const fields = fen.split(' ');
  let number = Number(fields[5]) || 1;
  let white = fields[1] !== 'b';
  const tokens: string[] = [];
  movesSan.forEach((san, index) => {
    if (white) tokens.push(`${number}.`);
    else if (index === 0) tokens.push(`${number}...`);
    tokens.push(san);
    if (!white) number++;
    white = !white;
  });
  tokens.push('*');
  return `${headers.join('\n')}\n\n${tokens.join(' ')}\n`;
}
